module.exports = __webpack_public_path__ + "img/close_icon.a350b97f.svg";